<template>
  <div class="additionalRecipientForm">
    <div class="d-flex">
      <TextField
        :model-value="modelValue"
        class="flex-1"
        label="Recipient Email"
        no-label
        data-cy="email"
        :error-message="firstErrorMessage(v$.email)"
        @update:model-value="emit('update:modelValue', $event)"
      />
      <div
        class="delete-icon ml-3"
        data-cy="remove-recipient"
        @click="emit('remove-recipient')"
      >
        <i class="fas fa-trash-alt"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { email, helpers, required } from "@vuelidate/validators";

const props = defineProps({
  modelValue: {
    type: String,
    default: () => ""
  }
});

const emit = defineEmits(["update:modelValue", "remove-recipient"]);

const v$ = useVuelidate(
  {
    email: {
      required: helpers.withMessage("Email is required", required),
      email
    }
  },
  { email: computed(() => props.modelValue) }
);

function validate() {
  const validated = v$.value.$validate();
  return validated;
}

defineExpose({ validate });
</script>

<style lang="scss" scoped>
.delete-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  min-width: 25px;
  i {
    font-size: 1rem;
  }
}
</style>
